export default "__VITE_PUBLIC_ASSET__a7595f98__"